import { Constants } from "@encoway/c-services-js-client"

import { IAppSettings } from "./appUtil"

export const defaultSettings: IAppSettings = {
    locale: "de-DE",
    configuration: {
        options: {
            rootGroup: "_CATALOGUE"
        },
        settings: {
            mappingOptions: {
                mappingProfile: Constants.MappingProfile.Maximum,
                pricingMappingType: "TOTAL"
            }
        }
    },
    visualization: {
        mode: "none",
        baseUrl: "https://visualization.encoway.cloud/vcs",
        token: "<Add your visualization token here>",
        version: "1.10.7",
        settings: {},
        settingsAssembly: {
            assembly: {
                resultBomType: "groupedCalculation"
            },
            features: {
                Gizmo: "on",
                OrientationIndicator: "on",
                ContextMenu: "right",
                HighlightHoverItem: "off"
            },
            ui: {
                configuration: {
                    newComponents: true
                },
                controls: {
                    autozoom: true
                },
                camera: {
                    near: 0.1,
                    far: 10000.0,
                    fov: 60.0,
                    position: { x: 100, y: 100, z: 100 }
                },
                contextMenu: {
                    rotation_roll: false,
                    rotation_flip: false
                },
                contextActions: true,
                globalDrop: true,
                background: 0xfafafa,
                lights: [
                    {
                        type: "ambient",
                        name: "#AmbientLight",
                        color: "#404040"
                    },
                    {
                        type: "directional",
                        position: { x: 2.6, y: 1, z: -3 },
                        name: "#BackLight",
                        intensity: 0.75
                    },
                    {
                        type: "directional",
                        position: { x: -2, y: -1, z: 1 },
                        name: "#FrontLight",
                        intensity: 0.75
                    },
                    {
                        type: "directional",
                        position: { x: 1, y: 4, z: 4 },
                        name: "#TopFrontLight",
                        intensity: 0.5
                    },
                    {
                        type: "directional",
                        position: { x: 0, y: 5, z: 0 },
                        name: "#TopLight",
                        intensity: 0.5
                    }
                ],
                components: {
                    catalog: "west",
                    header: false,
                    toolbar: "west"
                },
                sidebar: {
                    type: "panel"
                },
                toolbar: {
                    autozoom: true
                }
            }
        },
        settingsConfiguration: {
            features: {
                Gizmo: "off",
                OrientationIndicator: "on",
                Selection: "off",
                HighlightHoverItem: "off"
            },
            ui: {
                background: 0xfafafa,
                controls: {
                    /* rotation: true, */
                    autozoom: true
                },
                camera: {
                    near: 0.1,
                    far: 10000.0,
                    fov: 60.0,
                    light: false
                    /* position: { x: 100, y: 100, z: 100 } */
                },
                contextMenu: false,
                contextActions: false,
                globalDrop: false,
                lights: [
                    {
                        type: "ambient",
                        name: "#AmbientLight",
                        color: "#404040"
                    },
                    {
                        type: "directional",
                        position: {
                            x: 2.6,
                            y: 1,
                            z: -3
                        },
                        name: "#BackLight",
                        intensity: 0.75
                    },
                    {
                        type: "directional",
                        position: {
                            x: -2,
                            y: -1,
                            z: 1
                        },
                        name: "#FrontLight",
                        intensity: 0.5
                    },
                    {
                        type: "directional",
                        position: {
                            x: 1,
                            y: 4,
                            z: 4
                        },
                        name: "#TopFrontLight",
                        intensity: 0.75
                    }
                ],
                components: {
                    catalog: false,
                    header: false,
                    toolbar: "west"
                },
                toolbar: {
                    ViewIsometric: true,
                    ViewTop: true,
                    ViewFront: true,
                    select: false,
                    measure_distance: false,
                    dimensioning: false,
                    grid: false,
                    snap_objects: false,
                    help: false,
                    configuration: false,
                    autozoom: true
                }
            }
        }
    },
    translations: {},
    theme: {}
}
